declare namespace $ {

	type $mol_link_source__uri_giper_baza_app_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_source['uri'] >
	>
	type $mol_frame__title_giper_baza_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_frame['title'] >
	>
	type $mol_frame__uri_giper_baza_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_frame['uri'] >
	>
	type $giper_baza_glob_book__addon_tools_giper_baza_app_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $giper_baza_glob_book['addon_tools'] >
	>
	type $giper_baza_app_stat_page__tools_giper_baza_app_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $giper_baza_app_stat_page['tools'] >
	>
	type $giper_baza_auth_slot__tools_giper_baza_app_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $giper_baza_auth_slot['tools'] >
	>
	export class $giper_baza_app extends $mol_book2_catalog {
		Source( ): $mol_link_source
		Status( ): $giper_baza_status
		Info( ): $mol_frame
		Glob( ): $giper_baza_glob_book
		Stat( ): $giper_baza_app_stat_page
		Slot( ): $giper_baza_auth_slot
		menu_title( ): string
		param( ): string
		menu_foot( ): readonly(any)[]
		spreads( ): ({ 
			'info': ReturnType< $giper_baza_app['Info'] >,
			'glob': ReturnType< $giper_baza_app['Glob'] >,
			'stat': ReturnType< $giper_baza_app['Stat'] >,
			'slot': ReturnType< $giper_baza_app['Slot'] >,
		}) 
		placeholders( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=app.web.view.tree.d.ts.map